module.exports = function getResource(label, vars = []) {
    let resources = {
        copyright: `© ${vars[0]}`,
        allRightReserved: 'Sephora USA, Inc. All rights reserved.',
        termsOfUse: 'Terms of Use',
        privacyPolicy: 'Privacy Policy',
        phoneNumber1: '1-877-SEPHORA (1-877-737-4672)',
        phoneNumber2: 'TTY (1-888-866-9845)',
        findAStore: 'Find a Store',
        chat: 'Customer Service Chat',
        getTheApp: 'Get the App',
        textApp: `Text “APP” to ${vars[0]}`,
        regionAndLanguage: 'Region & Language',
        downloadApp: 'Download the Sephora App',
        siteMap: 'Sitemap',
        accessibility: 'Accessibility',
        iOSBanner: 'Download the Sephora App | Download on the App Store > for iOS',
        googlePlayBanner: 'Download the Sephora App | Get it on Google Play > for Android',
        belong: 'you belong to something beautiful.',
        weBelong: 'We Belong to',
        somethingBeautiful: 'Something Beautiful'
    };

    return resources[label];
};
